import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";
var Wrapper = styled.section.withConfig({
    componentId: "sc-6dd423ec-0"
})([
    "display:flex;align-items:center;justify-content:center;background:",
    ";border-bottom:1px solid ",
    ";height:70px;"
], Core.surface.inverse, Core.border.muted);
export var AccountSettingsBanner = function() {
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsx(Typography, {
            align: "center",
            variant: "pageHeaderSerifRegular",
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "j4pe1E",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Settings"
                    }
                ]
            })
        })
    });
};
